import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [!_vm.hasMailConnectors ? _c('core-n20-card', {
    staticClass: "dt-card-text-01 payload"
  }, [_c(VAlert, {
    staticClass: "mb-1",
    staticStyle: {
      "padding-left": "0px",
      "padding-top": "5px"
    },
    attrs: {
      "value": true,
      "color": "transparent",
      "icon": "fal fa-exclamation-circle"
    }
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.emails.noCofiguredEmails')) + "\n      ")])]), _vm._v("\n    " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.emails.useEmailSendout')) + "\n  ")], 1) : _c('div', [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "disabled": !_vm.hasMailConnectors,
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.types'),
      "items": _vm.mailConnectors,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "return-object": "",
      "readonly": _vm.readonly
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemAvatar, [_c(VAvatar, {
          attrs: {
            "size": "32"
          }
        }, [_vm.bridgeTypesIcons[data.item.type] ? _c('img', {
          attrs: {
            "src": _vm.bridgeTypesIcons[data.item.type],
            "alt": data.item.name,
            "title": data.item.name
          }
        }) : _vm._e()])], 1), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        }), _c(VListItemSubtitle, [_vm._v("\n                " + _vm._s(data.item.type.replace('bridge-', '')) + " (ID " + _vm._s(data.item.id) + ")\n              ")])], 1)];
      }
    }]),
    model: {
      value: _vm.internalModel.selectedMailConnector,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "selectedMailConnector", $$v);
      },
      expression: "internalModel.selectedMailConnector"
    }
  })], 1)], 1), _c('div', _vm._l(_vm.internalModel.emails, function (email, index) {
    return _c(VRow, {
      key: index,
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      attrs: {
        "cols": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.emails.email'),
        "rules": _vm.emailRules,
        "hide-details": "auto",
        "readonly": _vm.readonly
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('core-button', {
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.addNew'),
              "disabled": _vm.readonly,
              "prepend-icon": "fa-plus"
            },
            on: {
              "click": function ($event) {
                return _vm.addEmail(index);
              }
            }
          }), _c('core-button', {
            staticStyle: {
              "margin-left": "5px"
            },
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.delete'),
              "disabled": _vm.readonly,
              "prepend-icon": "fal fa-trash-alt"
            },
            on: {
              "click": function ($event) {
                return _vm.removeEmail(index);
              }
            }
          })];
        },
        proxy: true
      }], null, true),
      model: {
        value: _vm.internalModel.emails[index],
        callback: function ($$v) {
          _vm.$set(_vm.internalModel.emails, index, $$v);
        },
        expression: "internalModel.emails[index]"
      }
    })], 1)], 1);
  }), 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": 'subject',
      "hide-details": "auto",
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.internalModel.subject,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "subject", $$v);
      },
      expression: "internalModel.subject"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "8"
    }
  }, [_c(VTextarea, {
    attrs: {
      "label": 'html',
      "rows": "5",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": !_vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.internalModel.html,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "html", $$v);
      },
      expression: "internalModel.html"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "8"
    }
  }, [_c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.emails.attachFile'),
      "color": _vm.color,
      "hide-details": "",
      "inset": "",
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.internalModel.attachFile,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "attachFile", $$v);
      },
      expression: "internalModel.attachFile"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };